<template>
  <form @submit.prevent="productSearchForm">
    <div class="row" style="margin: 5px">
      <div class="col-8">
        <div class="form-group">
          <input
            id="criteria"
            v-model="criteria"
            type="text"
            name="criteria"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group text-center">
          <button id="btn-lookup" class="btn btn-info">
            <span v-if="loading">Loading...</span>
            <span v-else>Search</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="productResults.length > 2">
      <div class="search-results-container">
        <table class="table-striped">
          <tbody>
            <tr
              v-for="(product, i) in JSON.parse(productResults)"
              :key="'eclipse_product_' + i"
            >
              <td style="padding: 10px">
                <input
                  type="radio"
                  name="product_id"
                  :description="product.Description"
                  :price="product.Pricing.CustomerPrice"
                  :value="product.PartIdentifiers.EclipsePartNumber"
                  @change="handleEclipseProduct($event, indexModal)"
                />
              </td>
              <td style="padding: 10px">
                {{ product.Description }} -
                {{ product.PartIdentifiers.EclipsePartNumber }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center btn-search-submit">
        <button
          id="bundle_select"
          type="button"
          class="btn btn-primary"
          @click="handleCloseModal()"
        >
          Select
        </button>
      </div>
    </div>
    <div
      v-if="loading === false && productResults.length === 2"
      class="text-center"
    >
      no results found.
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      criteria: "",
    };
  },
  computed: {
    productResults() {
      return this.$store.state.product.eclipse_product_results;
    },
    indexModal() {
      return this.$store.state.product.index_modal;
    },
    loading() {
      return this.$store.state.product.loading_search_results;
    },
  },
  methods: {
    productSearchForm() {
      this.$store.dispatch("searchEclipseProduct", this.criteria);
    },
    getFormFields() {
      return { criteria: this.criteria };
    },
    handleEclipseProduct(event, indexModal) {
      const description = event.target.getAttribute("description");
      const eclipseProductId = event.target.value;
      const data = {
        description,
        index: indexModal,
        id: eclipseProductId,
      };
      this.$store.dispatch("setEclipseProductName", data);
    },
    handleCloseModal() {
      this.$store.dispatch("setModalState", false);
    },
  },
};
</script>
